import { useState } from 'react';
import { Link } from 'react-router';
import { Button, Icon, Modal } from '../../design';
import { fmtDateTime } from '../../lib/format';
import { GRANT_PURPOSE, type GrantPurpose } from './common';
import s from './operations.module.css';

/**
 * Codul unei chei, afișat o singură dată (spec §7). Trăiește doar în starea componentei părinte:
 * nu ajunge în cache-ul de query-uri, în URL sau în jurnale.
 */
export function CodeReveal({
  code,
  purpose,
  expiresAt,
  operationId,
  onClose,
}: {
  code: string;
  purpose: GrantPurpose;
  expiresAt: string;
  operationId?: string;
  onClose: () => void;
}) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
    } catch {
      const range = document.createRange();
      const el = document.getElementById('code-reveal-value');
      if (el) {
        range.selectNodeContents(el);
        const sel = window.getSelection();
        sel?.removeAllRanges();
        sel?.addRange(range);
      }
    }
  };
  return (
    <Modal
      title={`Cheie de ${GRANT_PURPOSE[purpose].toLowerCase()} emisă`}
      onClose={onClose}
      footer={
        <>
          {operationId && (
            <Link to={`/operatiuni/${operationId}`} onClick={onClose}>
              <Button>Deschide operațiunea</Button>
            </Link>
          )}
          <Button variant="primary" onClick={onClose}>
            Am notat codul
          </Button>
        </>
      }
    >
      <div className="stack">
        <div className={s.codeBox}>
          <div className="small muted" style={{ marginBottom: 6 }}>
            Cod de {GRANT_PURPOSE[purpose].toLowerCase()} · valabil până la {fmtDateTime(expiresAt)}
          </div>
          <div id="code-reveal-value" className={s.code} aria-label="Codul de acces">
            {code}
          </div>
          <div style={{ marginTop: 12 }}>
            <Button icon={copied ? 'check' : 'copy'} onClick={() => void copy()}>
              {copied ? 'Copiat' : 'Copiază codul'}
            </Button>
          </div>
        </div>
        <div className={s.warn} role="note">
          <Icon name="alert" size={18} />
          <span>
            Codul apare o singură dată și nu poate fi recuperat din consolă. Transmite-l
            destinatarului acum; dacă se pierde, emite o cheie nouă din detaliul operațiunii (cheile
            active anterioare se revocă).
          </span>
        </div>
      </div>
    </Modal>
  );
}
